<template>
    <div>
        <TempNavBar />
        <TempSideBar />
        <div id="contentys" class="container-fluid">
            <div class="header-contentys pt-3 d-flex align-items-center">
                <slot name="header"></slot>
            </div>
            <hr class="my-2">
            <div id="page-content" class="body-contentys pt-0 overflow-auto">
                <slot name="content"></slot>
            </div>
        </div>
        <TempFooter />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TempNavBar from '@/layouts/NavBar.vue'
import TempSideBar from '@/layouts/SideBar.vue'
import TempFooter from '@/layouts/FooterBar.vue'

export default defineComponent({
    name: 'App',
    components: { TempNavBar, TempSideBar, TempFooter },
})
</script>

<style scoped>
#yamsmanager {
    width: 100vh !important;
}

#page-content {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-height: 1px;
    height: 80vh !important;
    overflow-x: hidden !important;
}
</style>